module.exports = __webpack_public_path__ + "static/media/611.960e77d1.webp";